import type { DateBounds } from "../types";

export function isWithinBounds(date: Date, { min, max }: DateBounds): boolean {
  if (min && max && min.getTime() > max.getTime()) return false;
  const time = date.getTime();
  if (min && time < min.getTime()) return false;
  if (max && time > max.getTime()) return false;
  return true;
}
